<template>
  <v-dialog v-model="dialogAddPositionInGroup" persistent max-width="600px">
    <v-card class="pa-4">
      <v-card-title>
        <span class="dialog-member-title">เพิ่มกลุ่มระดับตำแหน่งงาน</span>
        <v-row justify="end" style="margin-top: -3%;">
          <v-btn
            x-small
            icon
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="mt-n2">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-end pa-0">
            <v-btn class="" dark outlined @click="addPositionList()">
              <v-icon left dark class="icon-eye-color" size="14px">fa-plus</v-icon>
              <span class="icon-eye-color ra-text-in-button-position">เพิ่มตำแหน่ง</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-form ref="form" class="overflow-x-hidden overflow-y-auto" style="max-height: 400px;">
              <div v-for="(input, k) in positionLvList" :key="k" class="pa-0 ma-0">
                <v-card class="mx-auto px-0 mb-5" style="border: 1px solid #EEEEEE;" elevation="0">
                  <v-row style="background-color: #EFF4FD" class="pa-0 ma-0">
                    <v-col cols="10">
                      <v-col
                        cols="10"
                        class="pa-0 d-flex flex-row justify-start"
                      >
                        <span class="txt-head"
                          >ลำดับที่ {{ k + 1 }}<span class="ml-1"></span
                          ><span
                            class="txt-font"
                            style="color: grey; font-size: 14px;"
                            >&nbsp;(</span
                          ><span style="color: red;">*</span
                          ><span
                            class="txt-font"
                            style="color: grey; font-size: 14px;"
                            >กรอกข้อมูลให้ครบถ้วน)</span
                          ></span
                        >
                      </v-col>
                    </v-col>
                    <v-col
                      v-if="positionLvList.length > 1"
                      cols="2"
                      class="pa-0 d-flex flex-row align-center justify-end"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            dark
                            icon
                            tile
                            class="mr-2"
                            @click="removePosition(k)"
                            v-show="k || (!k && positionLvList.length > 1)"
                          >
                            <template v-slot>
                              <v-icon dark color="#D1392B" size="19px"
                                >mdi-delete-outline</v-icon
                              >
                            </template>
                          </v-btn>
                        </template>
                        <span class="label-table-action">ลบข้อมูล</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row class="pl-5 pr-5 pt-2 pb-2 mb-n2">
                    <v-col cols="12" class="form-control pa-2">
                      <span>ชื่อตำแหน่ง</span>
                      <v-autocomplete
                        v-model="positionLvList[k].positionLvName"
                        :items="positionLevelName"
                        item-text="positionLvName"
                        item-value="_id"
                        clearable
                        dense
                        outlined
                        @input="handlePositionNameChange(k, positionLvList[k].positionLvName)"
                        placeholder="ชื่อตำแหน่ง"
                        :rules="[checkDuplicateInForm(k)]"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn class="button-color-outline" dark outlined @click="closeDialog()">ยกเลิก</v-btn>
          <v-btn v-if="checkValueList === false || isCheckDuplicate || isDuplicate.size > 0" class="button-color" color="grey" disabled>บันทึกข้อมูล</v-btn>
          <v-btn v-else class="button-color" dark @click="submitData()">บันทึกข้อมูล</v-btn>
      </v-card-actions>
      <div class="text-center">
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          absolute
          text
          top
          app
        >
          <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
          <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/EventBus'
import { getSelectPositionNew, validateInPositionLevelGroup, createPositionLevelInGroup } from '@/API/API'
import swal from 'sweetalert'

export default {
  data () {
    return {
      snackbar: false,
      text: '',
      timeout: 2000,
      snackbarColor: '',
      isCheckDuplicate: false,
      isDuplicate: new Set(),
      dialogAddPositionInGroup: false,
      positionGroupId: '',
      positionGroupName: '',
      positionLevelName: [],
      positionLvList: [
        {
          positionLvName: ''
        }
      ],
      templatePositionLvList: [
        {
          positionLvName: ''
        }
      ],
      token: ''
    }
  },
  computed: {
    checkValueList () {
      return this.positionLvList.every(item => item.positionLvName && item.positionLvName !== '')
    }
  },
  async created () {
    this.getPositioNewList()
  },
  mounted () {
    EventBus.$on('opendialogAddPositionInGroup', this.openDialogAddPositionInGroup)
  },
  beforeDestroy () {
    EventBus.$off('opendialogAddPositionInGroup')
  },
  methods: {
    openDialogAddPositionInGroup (value) {
      this.positionGroupId = value._id
      this.positionGroupName = value.positionGroupName
      this.token = this.$store.state.token
      this.dialogAddPositionInGroup = true
    },
    closeDialog () {
      this.positionLvList = this.templatePositionLvList
      this.$refs.form.resetValidation()
      this.dialogAddPositionInGroup = false
    },
    addPositionList () {
      this.positionLvList.push({
        positionLvName: ''
      })
    },
    removePosition (index) {
      this.positionLvList.splice(index, 1)
    },
    getPositionNameById (id) {
      return this.positionLevelName.find(item => item._id === id)
    },
    async handlePositionNameChange (index, positionLvName) {
      if (!positionLvName || positionLvName == null || positionLvName === '') return
      this.isCheckDuplicate = true
      if (await this.checkPositionHasAlreadyInGroup(index, positionLvName)) {
        this.text = 'ระดับตำแหน่งนี้ อยู่กลุ่มเรียบร้อยแล้ว'
        this.snackbarColor = 'error'
        this.snackbar = true
      }
      this.isCheckDuplicate = false
    },
    checkDuplicateInForm (index) {
      return (value) => {
        const normalizedValue = value && typeof value === 'string' ? value.trim().toLowerCase() : ''
        const names = this.positionLvList
          .map((item, i) => {
            if (i === index) return null
            const name = item?.positionLvName
            return typeof name === 'string' ? name.trim().toLowerCase() : null
          })
          .filter(name => name !== null)
        const isDuplicate = names.includes(normalizedValue)
        return isDuplicate ? 'ระดับตำแหน่ง ซ้ำกันภายในฟอร์ม' : true
      }
    },
    async checkPositionHasAlreadyInGroup (index, value) {
      try {
        const res = await validateInPositionLevelGroup({ id: this.positionGroupId, positionId: value }, this.token)
        if (res.success) {
          if (this.isDuplicate.has(index)) this.isDuplicate.delete(index)
          return false
        } else {
          if (this.isDuplicate.has(index)) this.isDuplicate.delete(index)
          this.isDuplicate.add(index)
          return true
        }
      } catch (error) {
        console.error('error message => ', error)
      }
    },
    async getPositioNewList () {
      const data = {
        companyId: '',
        companyName: '',
        positionLevel: '',
        positionLevelName: '',
        positionName: ''
      }
      try {
        const res = await getSelectPositionNew(data, this.token)
        if (res.success) {
          this.positionLevelName = res.positionLevelResult
        }
      } catch (error) {
        console.error('error message => ', error)
      }
    },
    async submitData () {
      if (this.$refs.form.validate() && this.isDuplicate.size === 0 && !this.isCheckDuplicate) {
        const data = {
          id: this.positionGroupId,
          positionIdList: this.positionLvList.map(item => item.positionLvName)
        }
        try {
          const res = await createPositionLevelInGroup(data, this.token)
          if (res.success) {
            swal('สำเร็จ', 'เพิ่มระดับตำแหน่งภายในกลุ่มเรียบร้อย', 'success', {
              button: false,
              timer: 2000
            })
            this.closeDialog()
          }
          EventBus.$emit('closedialogAddPositionInGroup')
        } catch (error) {
          console.error('error message => ', error)
        }
      }
    }
  }
}
</script>

<style scoped></style>
